import { FC, useEffect } from 'react'
import { useRouter } from 'next/router'
import styles from './adsense-control.module.scss'

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    adsbygoogle: any[]
  }
}

type AutoAdsProps = {
  enablePageLevelAds?: boolean
  enableAutoAds?: boolean
  adBreakTest?: 'on' | 'off'
}

// 自動広告は使わず、CSS制御のみで英語版に広告を制限
export const AutoAds: FC<AutoAdsProps> = () => {
  const router = useRouter()
  const isEnglish = router.locale === 'en'

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (isEnglish) {
        // 英語ページで広告要素を表示可能にする
        document.body.classList.add(styles.adSenseEnabled)
        document.body.classList.remove(styles.adSenseDisabled)

        // 開発環境でのデバッグログ
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('🟢 AdSense CSS ENABLED for EN page')
          // eslint-disable-next-line no-console
          console.log('🟢 Current locale:', router.locale)
          // eslint-disable-next-line no-console
          console.log('🟢 Body class:', document.body.className)
        }
      } else {
        // 日本語ページで広告要素を非表示にする
        document.body.classList.add(styles.adSenseDisabled)
        document.body.classList.remove(styles.adSenseEnabled)

        // 開発環境でのデバッグログ
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log('🔴 AdSense CSS DISABLED for non-EN page')
          // eslint-disable-next-line no-console
          console.log('🔴 Current locale:', router.locale)
          // eslint-disable-next-line no-console
          console.log('🔴 Body class:', document.body.className)
        }
      }
    }
  }, [isEnglish, router.locale])

  // このコンポーネントは視覚的な要素を持たない
  return null
}
